import { useContext } from 'react';
import Image from '@next/image';

import config from 'config';
import { FilesContext } from '@providers/FilesProvider';
import Link from '@components/atoms/Link';

import classes from './LeaselinkBanner.module.scss';

const { routes } = config;

const LeaselinkBanner = () => {
  const { getPageImageConfigs } = useContext(FilesContext);
  const [desktopImage, mobileImage] = getPageImageConfigs(['leaselink-desktop', 'leaselink-mobile']);

  return (
    <>
      {desktopImage && mobileImage && (
        <Link
          className={classes.wrapper}
          href={{
            pathname: routes.article.name.href,
            query: { name: 'leasing-online-sprzetu-dell-nowa-opcja-finansowania' },
          }}
        >
          <Image
            alt="leaselink"
            objectFit="cover"
            className={classes.desktopImage}
            resolveConfig={desktopImage}
            hasLazyLoad={false}
          />
          <Image
            alt="leaselink"
            objectFit="cover"
            className={classes.mobileImage}
            resolveConfig={mobileImage}
            hasLazyLoad={false}
          />
        </Link>
      )}
    </>
  );
};

export default LeaselinkBanner;
